const CLASSIFICACAO_ANALISE_SITUACAO = {
  ATIVO: 'ATIVO',
  INATIVO: 'INATIVO',
};

export default CLASSIFICACAO_ANALISE_SITUACAO;
